import { ArrowForward } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { DocumentFormField } from "./DocumentFormField";

export const DocumentInfo = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  const natureOptions = [
    {
      label: "Debit",
      value: "D",
    },
    {
      label: "Credit",
      value: "C",
    },
    {
      label: "Blank",
      value: null,
    }
  ]

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <ArrowForward style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Details")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <DocumentFormField label={t("Code")} type="text" code="Code" data={dataState} setData={setDataState} />
            <DocumentFormField label={t("Description")} type="text" code="Description" data={dataState} setData={setDataState} />
            <DocumentFormField label={t("Quantity")} type="number" code="Quantity" data={dataState} setData={setDataState} />
            <DocumentFormField label={t("DetailedCopy")} type="number" code="DetailedCopy" data={dataState} setData={setDataState} />
            <DocumentFormField label={t("Nature")} type="select" code="Nature" options={natureOptions} extraField="NatureValue" data={dataState} setData={setDataState} />
            <DocumentFormField label={t("ExportSAFT")} type="checkBox" code="ExportSAFT" data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}